module.exports = {"title":"Lin Clark","talk":"A cartoon guide to performance in React","path":"/speakers/lin-clark","type":"speaker","slug":"lin-clark","twitter":"linclark","github":"linclark","website":"http://lin-clark.com/","companyWebsite":"https://www.mozilla.org","company":"Mozilla","body":"<p>Everyone talks about how performant React is... but why? What makes  people talk about how speedy React is? In this talk, you'll learn <strong>why</strong> people talk about React being fast, and what you can do to make it faster.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/lin-clark.md
 ** module id = 542
 ** module chunks = 0
 **/